module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_is-object.js
// module id = 4
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11